<template>
  <div>
    <el-dialog
      :title="followSettingData.title"
      :visible.sync="followSettingData.show"
      center
      width="400px"
    >
      <el-form
        :inline="true"
        :model="formData"
        label-width="100px"
        v-loading="followSettingData.loading"
      >
        <el-form-item :label="$t('channel')">
          <el-select
            v-model="formData.ChannelId"
            :placeholder="$t('channel')"
            @change="changeChannelId"
            clearable
          >
            <el-option
              v-for="item in channel"
              :key="item.ChannelId"
              :label="item.Name"
              :value="item.ChannelId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属顶级代理">
          <el-select
            v-model="formData.TopAgentId"
            @change="changeTopAgentId"
            filterable
            placeholder="所属顶级代理"
            clearable
          >
            <el-option
              v-for="(item, index) in dataList"
              :key="index"
              :label="item.name"
              :value="item.TopAgentId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('GameType')">
          <el-select
            v-model="formData.gameType"
            @change="changeGameType"
             :placeholder="$t('GameType')"
            clearable
          >
            <el-option
              v-for="item in gameTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('GameName')">
          <el-select
            v-model="formData.GameId"
            @change="changeGameId"
            :placeholder="$t('GameName')"
            clearable
          >
            <el-option
              v-for="item in games"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <div style="color: red">勾选的游戏，跟随此游戏的设置</div>
        </el-form-item>
        <el-form-item label="游戏场次">
          <el-select
            @change="changeRoomLevel"
            v-model="formData.RoomLevel"
            :placeholder="$t('session')"
            clearable
          >
            <el-option
              v-for="item in roomsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitEditRow"
          >{{$t('Confirm')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import base from "@/api/base.js";
import { app } from "@/api/app.js";
export default {
  extends: base,
  props: {
    followSettingData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        ChannelId: "",
        TopAgentId: "",
        gameType: "",
        GameId: "",
        RoomLevel: "",
        GameName: "",
        Id: "",
        Address: "",
      },
      roomsList: [],
      gameTypeList: [],
      TopAgentList: [],
      dataList: [],
      resultList: [],
      gameType: "",
      objData: {},
      curChannelList: [], // 选择渠道之后筛选出来的所有数据
      games: [],
    };
  },
  created() {
    this.app = app;
    this.getChannel(this.filters.SellerId);
    this.getTopAgentData();
  },
  methods: {
    getTopAgentData() {
      let data = {
        page: 1,
        pagesize: 50000,
        SellerId: parseInt(this.filters.SellerId || 0),
        GameId: [],
        GameType: 0,
        ChannelId: 0,
        RoomLevel: 0,
        TopAgentId: [],
        Address: "",
      };
      app.post("/game/list", data, (res) => {
        this.TopAgentList = res.data.data;
        this.followSettingData.loading = false;
      });
    },
    changeChannelId() {
      this.curChannelList = this.TopAgentList.filter(
        (item) => item.ChannelId == this.formData.ChannelId // 筛选出所选渠道的所有数据
      );
      let result = [];
      let map = new Map();
      result = this.curChannelList.filter(
        (item) => !map.has(item.TopAgentId) && map.set(item.TopAgentId, 1)
      ); // 去重顶级ID
      let obj = {};
      console.log(result);
      result.forEach((item, index) => {
        if (item.TopAgentId == 0) {
          item.name = `官网(${item.TopAgentId})`;
          obj = item;
          result.splice(index, 1);
        } else {
          item.name = `${item.AgentName || ""}(${item.TopAgentId})`;
        }
      });
      result.unshift(obj);
      this.dataList = result;
      this.formData.TopAgentId = "";
      this.formData.gameType = "";
      this.formData.GameId = "";
      this.formData.RoomLevel = "";
    },
    changeTopAgentId() {
      if (!this.formData.ChannelId)
        return this.$message.warning("请先选择渠道");
      this.formData.gameType = "";
      this.formData.GameId = "";
      this.formData.RoomLevel = "";
      let data = this.curChannelList.filter(
        (item) => item.TopAgentId == this.formData.TopAgentId
      );
      let dd = {};
      data.forEach((item) => {
        if (item.GameId < 100 || item.GameId > 300) {
          dd[-1] = 1;
        } else if (item.GameId > 100 && item.GameId <= 205) {
          dd[-2] = 1;
        } 
      });

      let gt = [];
      for (let v in dd) {
        if (v == -1) {
          gt.push({ id: -1, Name: this.$t('common.comFooter.game1') });
        }
        if (v == -2) {
          gt.push({ id: -2, name: this.$t('balanceHash') });
        }
      }
      this.gameTypeList = gt;
    },
    changeGameType() {
      if (this.formData.TopAgentId === "") {
        this.formData.gameType = "";
        return this.$message.warning("请先选择所属顶级代理");
      }
      let data = this.curChannelList.filter(
        (item) => item.TopAgentId == this.formData.TopAgentId
      );

      let gi = {};
      data.forEach((item) => {
        if (this.formData.gameType === -1 && (item.GameId < 100 || item.GameId > 300)) {
          gi[item.GameId] = true;
        } else if (this.formData.gameType === -2 && item.GameId > 100 && item.GameId <= 205) {
          gi[item.GameId] = true;
        }
      });

      this.games = this.hgames.filter((item) => gi[item.id]);
      this.formData.GameId = "";
      this.formData.RoomLevel = "";
    },
    changeGameId() {
      if (!this.formData.gameType) {
        this.formData.GameId = "";
        return this.$message.warning("请先选择游戏类型");
      }
      let data = this.curChannelList.filter(
        (item) => item.TopAgentId == this.formData.TopAgentId
      );

      data = data.filter((item) => item.GameId == this.formData.GameId);
      let r = {};
      data.forEach((item) => {
        r[item.RoomLevel] = 1;
      });
      let ri = [];

      for (let v in r) {
        if (v == 1) {
          ri.push({ id: 1, name: this.$t('BeginnerRoom') });
        }
        if (v == 2) {
          ri.push({ id: 2, name: this.$t('IntermediateRoom') });
        }
        if (v == 3) {
          ri.push({ id: 3, name: this.$t('AdvancedRoom')});
        }
      }
      this.roomsList = ri;
      this.formData.RoomLevel = "";
    },
    changeRoomLevel() {
      if (!this.formData.GameId) {
        this.formData.RoomLevel = "";
        return this.$message.warning("请先选择游戏名称");
      }
    },
    submitEditRow() {
      let data = this.curChannelList.filter(
        (item) => item.TopAgentId == this.formData.TopAgentId
      );
      data = data.filter((item) => item.GameId == this.formData.GameId);
      data = data.filter((item) => item.RoomLevel == this.formData.RoomLevel);
      this.formData.GameName = data[0].GameName;
      this.formData.Id = data[0].Id;
      this.formData.Address = data[0].Address;
      this.$emit("submitFollowSettingData", this.formData);
    },
  },
};
</script>

<style scoped></style>
